export enum FriendRequestStatus {
  Accepted = 'accepted',
  Pending = 'pending',
}
